<template>
<div>
    <x-header @on-click-back="xback" :left-options="{preventGoBack:true}">订餐查询</x-header>   
    <button-tab>
      <button-tab-item @on-item-click='dtoday' selected>今天</button-tab-item>
      <button-tab-item @on-item-click='dweek'>本周</button-tab-item>
      <button-tab-item @on-item-click='dmonth'>本月</button-tab-item>
    </button-tab>

    <divider v-show='dataList.length<=0'>无订餐记录</divider>

    <group v-show='dataList.length>0' v-for='(item,index) in dataList' :key="'t'+index">
      <cell :title="item.declareName">
        <marquee>
          <marquee-item v-for="i in 5" :key="'x'+i" class="align-left">{{item.rs}}人</marquee-item>
        </marquee>
      </cell>
    </group>
</div>
</template>


<script>
import { XHeader, Divider,Grid, GridItem, GroupTitle,ButtonTab,ButtonTabItem,Group, Cell, Marquee, MarqueeItem } from 'vux'

export default {
  created(){
    this.xtype=1
    this.initData()
  },
  data () {
    return {
      asyncCount: 5,
      xtype:1,
      tout: null,
      dataList:[]
    }
  },
  methods:{
    xback(){
      this.$router.push("wap")
    },
    dtoday(){
      if (this.xtype != 1){
        this.xtype=1
        this.initData()
      }
    },
    dweek(){
      if (this.xtype != 2){
        this.xtype=2
        this.initData()
      }
    },
    dmonth(){
      if (this.xtype != 3){
        this.xtype=3
        this.initData()
      }
    },
    initData(){
      if (this.tout) clearTimeout(this.tout)
      this.$getData(this.$baseUrl+"DinnerDeclare/GetRC?type=" + this.xtype, data=>{
        if (data.rs==1){
          this.dataList = data.list
          console.log(this.dataList)
        }
        
      this.tout = setTimeout(() => {
        this.initData()
      }, 5000)
      })
    }
  },
  mounted () {
    setTimeout(() => {
      this.asyncCount = 5
    }, 1000)
  },
  components: {
    Divider,
    XHeader,
    Grid, 
    GridItem, 
    GroupTitle,
    ButtonTab,
    ButtonTabItem,Group, Cell, Marquee, MarqueeItem
  }
}
</script>
<style scoped>
document body {
  background-color: #fff import;
}
.grid-center {
  display: block;
  text-align: center;
  color: #666;
}
.weui-grids {
  background-color: #fff;
}
.align-middle {
  text-align: center;
}
</style>
